/**
 * Admin API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocationData } from './location-data';
import { MessagingPhoneNumber } from './messaging-phone-number';
import { BusinessRegistrationInfo } from './business-registration-info';


export interface EpnConfigurationCommand { 
    name?: string;
    domainName?: string;
    efan?: string;
    primaryPhoneNumber?: MessagingPhoneNumber;
    scheduler?: boolean;
    forms?: boolean;
    recallReports?: boolean;
    receiveValueReport?: boolean;
    secureNotifications?: boolean;
    locationData?: Array<LocationData>;
    recallReportDayOf?: number;
    recallReportWeekOf?: number;
    recallReportHourToRun?: string;
    timeBeforeType?: EpnConfigurationCommand.TimeBeforeTypeEnum;
    useEyefinityEndpoint?: boolean;
    businessRegistrationInfo?: BusinessRegistrationInfo;
}
export namespace EpnConfigurationCommand {
    export const TimeBeforeTypeEnum = {
        Monthly: 'MONTHLY',
        Weekly: 'WEEKLY'
    } as const;
    export type TimeBeforeTypeEnum = typeof TimeBeforeTypeEnum[keyof typeof TimeBeforeTypeEnum];
}


